module.exports = "/_next/static/images/32bd084ae39dd05aafb051e39eb60f64-pj-person-making-card-purchase@1x.jpg.webp";